// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ellipsis---qEeST {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.profile---iJBsJ {
  display: flex;
}
.pictureCursor---NCMLJ {
  cursor: pointer;
}
.pictureLarge---dZZqq {
  width: 150px;
  height: 150px;
  object-fit: cover;
  border-radius: 50%;
  margin-right: 33px;
  cursor: pointer;
}
.pictureSmall---bpKp3 {
  width: 31px;
  height: 31px;
  border-radius: 31px;
  margin-right: 12px;
  cursor: pointer;
}
.usernameWrapper---hvLlF {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.usernameLarge---tcdSh {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-family: 'Segoe UI', Roboto, Helvetica;
  font-size: 30px;
  color: #262626;
  letter-spacing: -0.8px;
}
.usernameSmall---HdfQZ {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-family: 'Segoe UI', Roboto, Helvetica;
  font-size: 16px;
  color: #262626;
  letter-spacing: -0.37px;
}
.name---BEn1V {
  padding-top: 20px;
  font-family: 'Segoe UI', Roboto, Helvetica;
  font-size: 16px;
  font-weight: bold;
  color: #01376b;
  letter-spacing: 0;
}
`, "",{"version":3,"sources":["webpack://./src/components/profile.less"],"names":[],"mappings":"AAAA;EACE,mBAAA;EACA,gBAAA;EACA,uBAAA;AACF;AAEA;EACE,aAAA;AAAF;AAGA;EACE,eAAA;AADF;AAIA;EACE,YAAA;EACA,aAAA;EACA,iBAAA;EACA,kBAAA;EAEA,kBAAA;EATA,eAAA;AAOF;AAMA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EAEA,kBAAA;EAlBA,eAAA;AAcF;AAQA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;AANF;AASA;EAtCE,mBAAA;EACA,gBAAA;EACA,uBAAA;EAsCA,0CAAA;EACA,eAAA;EACA,cAAA;EACA,sBAAA;AALF;AAQA;EA9CE,mBAAA;EACA,gBAAA;EACA,uBAAA;EA8CA,0CAAA;EACA,eAAA;EACA,cAAA;EACA,uBAAA;AAJF;AAOA;EACE,iBAAA;EAEA,0CAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,iBAAA;AANF","sourcesContent":[".ellipsis {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.profile {\n  display: flex;\n}\n\n.pictureCursor {\n  cursor: pointer;\n}\n\n.pictureLarge {\n  width: 150px;\n  height: 150px;\n  object-fit: cover;\n  border-radius: 50%;\n\n  margin-right: 33px;\n  .pictureCursor;\n}\n\n.pictureSmall {\n  width: 31px;\n  height: 31px;\n  border-radius: 31px;\n\n  margin-right: 12px;\n  .pictureCursor;\n}\n\n.usernameWrapper {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}\n\n.usernameLarge {\n  .ellipsis;\n  font-family: 'Segoe UI', Roboto, Helvetica;\n  font-size: 30px;\n  color: #262626;\n  letter-spacing: -0.8px;\n}\n\n.usernameSmall {\n  .ellipsis;\n  font-family: 'Segoe UI', Roboto, Helvetica;\n  font-size: 16px;\n  color: #262626;\n  letter-spacing: -0.37px;\n}\n\n.name {\n  padding-top: 20px;\n\n  font-family: 'Segoe UI', Roboto, Helvetica;\n  font-size: 16px;\n  font-weight: bold;\n  color: #01376b;\n  letter-spacing: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"ellipsis": `ellipsis---qEeST`,
	"profile": `profile---iJBsJ`,
	"pictureCursor": `pictureCursor---NCMLJ`,
	"pictureLarge": `pictureLarge---dZZqq`,
	"pictureSmall": `pictureSmall---bpKp3`,
	"usernameWrapper": `usernameWrapper---hvLlF`,
	"usernameLarge": `usernameLarge---tcdSh`,
	"usernameSmall": `usernameSmall---HdfQZ`,
	"name": `name---BEn1V`
};
export default ___CSS_LOADER_EXPORT___;
